export default __webpack_public_path__ + "static/media/feedback.73fe15b0.png";